<template>
  <div class="live-match">
    <HeaderMatch
      :league="league"
      :time-level-class="timeLevelClass"
      :is-favorite="isFavorite"
      :mini="mini"
      @favorite="() => $emit('favorite')"
      @view="() => $emit('view')"
    />
    <div class="live-body">
      <div class="team team_start">
        <div class="club-wrap">
          <h1 class="club-title">{{ home.name }}</h1>
          <WinCoef class="cofficient" :value="home.winCoef" />
        </div>
        <div class="goals start">
          <div class="goal_wrap">
            <span
              class="goal_total home"
              :style="{
                color:
                  isHomeGoal || isHomeNoGoal
                    ? 'var(--danger-color)'
                    : 'var(--fontColor)',
              }"
              >{{ home.score }}</span
            >
            <div class="cards">
              <span v-if="home.redCard" class="red-card">{{
                home.redCard
              }}</span>
              <span v-if="home.yellowCards" class="yellow-card">{{
                home.yellowCards
              }}</span>
              <div
                v-if="!home.redCard && !home.yellowCards"
                style="width: 28px; height: 30px"
              ></div>
            </div>
            <h3 v-if="isHomeGoal" class="score_change">Goal!!!</h3>
            <h3 v-if="isHomeNoGoal" class="score_change canceled">
              Goal Cancelled
            </h3>
          </div>
          <div v-if="home.goalTime.length > 0" class="goal_time">
            <GateIcon fill="var(--font-color)" />
            <div class="block"></div>
            <div class="wrap">
              <span v-for="time in home.goalTime" :key="time">
                {{ time }}'
              </span>
            </div>
          </div>
          <!-- <div class="goal_time" v-if="home.redCards.length > 0">
            R
            <div class="block"></div>
            <div class="wrap">
              <span v-for="time in home.redCards" v-bind:key="time">
                {{ time }}'
              </span>
            </div>
          </div>
          <div class="goal_time" v-if="home.penalties.length > 0">
            P
            <div class="block"></div>
            <div class="wrap">
              <span v-for="time in home.penalties" v-bind:key="time">
                {{ time }}'
              </span>
            </div>
          </div> -->
          <div v-if="home.goalTime.length == 0" style="height: 41px"></div>
        </div>
      </div>
      <LiveStatistics
        :id="id"
        :time="match.time"
        :over-hdp="match.overHdp"
        :total-hdp="match.totalHdp"
        :under-hdp="match.underHdp"
        :over="match.over"
        :total="match.total"
        :under="match.under"
        :stat-list="statList"
        :home="home"
        :away="away"
        :home-level-class="match.$homeLevel"
        :away-level-class="match.$awayLevel"
        :first-time="match.firstTime"
        :ended="match.ended"
        :odds="match.odds"
      />
      <div class="team team_end">
        <div class="club-wrap">
          <h1 class="club-title">{{ away.name }}</h1>
          <WinCoef class="cofficient" :value="away.winCoef" />
        </div>

        <div class="goals end">
          <div class="goal_wrap">
            <span
              class="goal_total away"
              :style="{
                color:
                  isAwayGoal || isAwayNoGoal
                    ? 'var(--danger-color)'
                    : 'var(--fontColor)',
              }"
              >{{ away.score }}</span
            >
            <div class="cards">
              <span v-if="away.redCard" class="red-card">{{
                away.redCard
              }}</span>
              <span v-if="away.yellowCards" class="yellow-card">{{
                away.yellowCards
              }}</span>
              <div
                v-if="!away.redCard && !away.yellowCards"
                style="width: 28px; height: 30px"
              ></div>
            </div>
            <h3 v-if="isAwayGoal" class="score_change">Goal!!!</h3>
            <h3 v-if="isAwayNoGoal" class="score_change canceled">
              Goal Cancelled
            </h3>
          </div>
          <div v-if="away.goalTime.length > 0" class="goal_time">
            <GateIcon fill="var(--font-color)" />
            <div class="block"></div>
            <div class="wrap">
              <span v-for="time in away.goalTime" :key="time">
                {{ time }}'
              </span>
            </div>
          </div>
          <!-- <div class="goal_time" v-if="away.redCards.length > 0">
            R
            <div class="block"></div>
            <div class="wrap">
              <span v-for="time in away.redCards" v-bind:key="time">
                {{ time }}'
              </span>
            </div>
          </div>
          <div class="goal_time" v-if="away.penalties.length > 0">
            P
            <div class="block"></div>
            <div class="wrap">
              <span v-for="time in away.penalties" v-bind:key="time">
                {{ time }}'
              </span>
            </div>
          </div> -->
          <div v-if="away.goalTime.length == 0" style="height: 41px"></div>
        </div>
      </div>
    </div>
    <SignalsLive v-if="liveSignals.length" :signals="liveSignals" />
    <!-- <div v-if="permision==='isDev'" v-html="highlightedString"></div>
    <div
      v-if="permision==='isDev'"
      v-for="(log, key) in match.logsignals"
      :key="key"
      style="background-color: antiquewhite; margin-bottom: 5px"
    >
      {{ log }}
    </div> -->
  </div>
</template>

<script>
import LiveStatistics from "./common/LiveStatistics.vue";
import GateIcon from "./common/icons/Gate.vue";
import WinCoef from "./common/WinCoef.vue";
import SignalsLive from "./common/SignalsLive.vue";
import HeaderMatch from "./common/HeaderMatch.vue";

export default {
  name: "LiveMatch",
  components: {
    LiveStatistics,
    GateIcon,
    WinCoef,
    SignalsLive,
    HeaderMatch,
  },
  props: {
    id: Number,
    timeLevel: Number,
    away: Object,
    home: Object,
    part: String,
    league: String,
    mini: Boolean,
    isFavorite: Boolean,
    match: Object,
    permision: String,
    liveSignals: {
      type: Array,
      default: () => [],
    },
    // CSS Classes
    timeLevelClass: String,
  },
  data: () => ({
    openStatistic: false,
    statList: [
      { title: "PPM", key: "ppm" },
      { title: "Scored", key: "goal" },
      { title: "Conceded", key: "loss" },
      { title: "xG", key: "xg" },
      { title: "Dang. Attack", key: "dAtk" },
      { title: "Shots", key: "shots" },
      { title: "On Target", key: "sOn" },
      { title: "Off Target", key: "sOff" },
      { title: "Corners", key: "cornerKicks" },
      { title: "Corners Avg.", key: "corner" },
    ],
  }),
  computed: {
    highlightedString() {
      let result = this.match.logInfo;

      result = result.replace(
        /true/g,
        '<span style="background-color: green;">true</span>',
      );
      result = result.replace(
        /false/g,
        '<span style="background-color: red;">false</span>',
      );

      return result;
    },
    isHomeGoal() {
      return this.home.lastGoal && this.home.lastGoal > this.home.lastNoGoal
        ? new Date().getTime() - this.home.lastGoal < 60 * 1000
        : false;
    },
    isAwayGoal() {
      return this.away.lastGoal && this.away.lastGoal > this.away.lastNoGoal
        ? new Date().getTime() - this.away.lastGoal < 60 * 1000
        : false;
    },
    isHomeNoGoal() {
      return this.home.lastNoGoal && this.home.lastGoal < this.home.lastNoGoal
        ? new Date().getTime() - this.home.lastNoGoal < 60 * 1000
        : false;
    },
    isAwayNoGoal() {
      return this.away.lastNoGoal && this.away.lastGoal < this.away.lastNoGoal
        ? new Date().getTime() - this.away.lastNoGoal < 60 * 1000
        : false;
    },
  },
  methods: {
    sm(obj) {
      let $class = "";
      if (obj.hasOwnProperty("level")) {
        $class = this.$utils.match.getLevelClass(obj.level, "is");
      } else if (obj.hasOwnProperty("time")) {
        const time = obj.time.split("~");
        const timeLevel = this.getSMTimeLevel(time[0]);
        $class = this.$utils.match.getLevelClass(timeLevel, "is");
      }
      return `<span class="tag ${$class}">${obj.time}</span>`;
    },
    getSMTimeLevel(time) {
      switch (Number(time)) {
        case 1:
        case 16:
        case 31:
          return 1;
        case 61:
          return 2;
        case 76:
          return 3;
        default:
          return 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.live-match {
  margin-bottom: 26px;
  border-radius: 26px;
  overflow: hidden;

  .team-level-success {
    background-color: var(--success-background) !important;
  }

  .team-level-danger {
    background-color: var(--danger-background) !important;
  }

  .team-level-warning {
    background-color: var(--warning-background) !important;
  }

  .yellow-card {
    background-color: #ffe500;
    padding: 5px 10px 5px 10px;
    width: 28px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: #151515;
    font-weight: 400;
    font-size: 12px;
    line-height: 14.52px;
  }

  .red-card {
    background-color: #ff4e4e;
    padding: 5px 10px 5px 10px;
    width: 28px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: white;
    font-weight: 400;
    font-size: 12px;
    line-height: 14.52px;
  }

  .live-body {
    display: flex;
    width: 100%;
    height: max-content;
    justify-content: space-between;
    align-items: flex-start;
    padding: 20px 40px 20px 40px;
    background-color: var(--league-body-color);

    .team {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

      .club-wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .club-title {
        overflow: hidden;
        font-weight: 700;
        font-size: 24px;
        line-height: 30.05px;
        margin-bottom: 44px;
      }

      .cofficient {
        font-weight: 400;
        font-size: 20px;
        line-height: 24.8px;
        margin-bottom: 7px;
      }

      .goals {
        display: flex;
        flex-direction: column;
        align-items: center;

        .goal_wrap {
          position: relative;
          display: flex;
          gap: 5px;
          align-items: center;
          padding: 15px 15px 45px 15px;
          margin-bottom: 5px;

          .score_change {
            position: absolute;
            bottom: 0;
            font-size: 24px;
            color: var(--danger-color);
            background-color: #fff;
            border-radius: 16px;
            padding: 5px 12px;
            text-transform: uppercase;
            font-family: sans-serif;
            font-weight: bolder;
            animation: goal 1s infinite;
            transform-origin: center;
          }

          .canceled {
            font-size: 16px;
            line-height: 20px;
            text-align: center;
            bottom: -5px;
            padding: 2px 5px;
          }

          .cards {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
          }

          @keyframes goal {
            0% {
              transform: translateY(0) scale(1);
            }

            50% {
              transform: translateY(-10px) scale(1.1);
            }

            100% {
              transform: translateY(0) scale(1);
            }
          }
        }

        .goal_wrap:has(.score_change) {
          padding-top: 0;
          margin-bottom: 20px;
        }
      }

      .goal_total {
        font-weight: 700;
        font-size: 150px;
        line-height: 1;
        max-height: 107px;
        font-weight: 700;
        letter-spacing: 0.02em;
        text-align: center;
        margin-bottom: 85px;
        display: contents;
        vertical-align: middle;
      }

      .home {
        color: var(--font-color);
      }

      .away {
        color: var(--font-color);
      }

      .goal_time {
        display: flex;
        align-items: center;
        gap: 10px;
        width: max-content;
        padding: 8px 16px 8px 16px;
        border-radius: 50px;
        background-color: var(--shots-body-color);

        .gate path {
          fill: var(--live-gate-body-color);
          transition: fill 0.3s;
        }

        .block {
          width: 1px;
          height: 15px;
          background-color: #dadada;
          margin: 0;
        }

        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 17.36px;
          color: var(--font-color);
        }
      }

      .wrap {
        display: flex;
        gap: 10px;
        align-items: center;
        overflow: auto;
        cursor: pointer;
        max-width: 270px;
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .live-body {
      .goal_time {
        .wrap {
          max-width: 180px;
        }
      }

      .team .goal_wrap {
        margin-bottom: 0 !important;
      }
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) {
    .live-body {
      grid-template-columns: repeat(3, 1fr);
      display: grid;
      padding: 20px;

      .club-wrap {
        .club-title {
          font-size: 16px;
          margin-bottom: 10px;
        }
      }

      .team {
        height: 100%;
        justify-content: space-between;

        .start {
          flex-direction: row-reverse;
        }

        .end {
          flex-direction: row;
        }

        .goals {
          gap: 20px;
          align-items: end;

          .goal_wrap {
            padding-bottom: 80px;
          }

          .goal_total {
            margin-bottom: 29px;
          }

          .goal_time {
            flex-direction: column;
            padding: 16px 8px 16px 8px;

            .block {
              height: 1px;
              width: 15px;
            }

            .wrap {
              flex-direction: column;
              max-height: 210px;
              overflow: auto;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .live-body {
      grid-template-columns: repeat(2, 1fr);
      display: grid;
      padding: 15px;

      .club-wrap {
        .club-title {
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 16px;
          margin-bottom: 10px;
          max-width: 120px;
        }
      }

      .team_start {
        align-items: start;
      }

      .team_end {
        order: 1;
        align-items: end;
      }

      .team {
        height: 100%;
        justify-content: space-between;
        align-items: center;

        .start {
          flex-direction: row;
        }

        .end {
          flex-direction: row-reverse;
        }

        .goals {
          // gap: 20px;
          align-items: end;

          .goal_wrap {
            padding: 15px 5px 45px 5px;
          }

          .goal_total {
            margin-bottom: 29px;
          }

          .goal_time {
            flex-direction: column;
            padding: 16px 8px 16px 8px;

            .block {
              height: 1px;
              width: 15px;
            }

            .wrap {
              flex-direction: column;
              max-height: 210px;
              overflow: auto;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 468px) {
    .live-body {
      padding: 10px !important;

      .team {
        .goal_wrap {
          flex-direction: column;
          padding: 15px 0 50px 0 !important;

          .cards {
            flex-direction: row !important;
          }

          .goals {
            gap: 0 !important;
          }
        }
      }
    }
  }
}
</style>
